export default class ResidentData {
  name?: string;
  phoneNumber?: string;
  unit?: string;
  unitId?: string;
  unitName?: string;
  unitCode?: string;
  personTypeId?: string;
  constructor(
    name?: string,
    phoneNumber?: string,
    unit?: string,
    unitId?: string,
    unitName?: string,
    unitCode?: string,
    personTypeId?: string
  ) {
    this.name = name;
    this.phoneNumber = phoneNumber;
    this.unit = unit;
    this.unitId = unitId;
    this.unitName = unitName;
    this.unitCode = unitCode;
    this.personTypeId = personTypeId;
  }
}
